import { FieldProps } from 'formik';
import React from 'react';

interface Props extends FieldProps {
  label: string;
  icon: string;
  onClick: () => void;
}

export function PaymentOptionItem({ label, form, field, icon, onClick }: Props) {
  const isSelected = form.values[field.name] === field.value;

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
    form.setFieldValue(field.name, field.value);
  };

  return (
    <div
      onClick={handleClick}
      className={`min-w-38 p-4 text-center rounded-8 cursor-pointer ${
        isSelected ? 'border-2 border-blue-600' : 'border-[0.6px] border-grey-200'
      }`}
    >
      <img src={icon} alt={field.name} />
      <p className="mt-2 text-base text-center">{label}</p>
    </div>
  );
}
